<template>
  <split-section>
    <b-row>
      <b-col class="py-1">
        <h3>Upcoming Events</h3>
      </b-col>
    </b-row>
    <b-row v-for="event in events" :key="event.id">
      <b-col>
        <event-item :event="event" />
      </b-col>
    </b-row>
    <b-row v-if="events.length == 0">
      <b-col>No upcoming events..</b-col>
    </b-row>
  </split-section>
</template>

<script lang="ts">
import FacebookApiService from "../services/FacebookApiService";

import EventItem from "./EventItem.vue";
import SplitSection from "./SplitSection.vue";

export default {
  components: {
    EventItem,
    SplitSection
  },
  data() {
    return {
      events: []
    };
  },
  created() {
    FacebookApiService.GetFacebookEvents().then(events => {
      this.events = events;
    });
  }
};
</script>